import { useRef, useState } from "react";
import { Outlet } from "react-router-dom";

const DEFAULT_CLASSNAMES = {
  container: "hover:cursor-pointer",
  slider:
    "z-40 backdrop-blur-sm h-full w-1 active:shadow hover:shadow shadow-black shadow-sm active:bg-primary bg-greenGlass hover:bg-primary absolute right-0 bottom-0 w-2 cursor-col-resize",
};

const Sidebar = ({ children, classNames = DEFAULT_CLASSNAMES }) => {
  const [width, setWidth] = useState(250);
  const sidebarRef = useRef(null);

  const handleResize = (newWidth) => {
    setWidth(newWidth);
    sidebarRef.current.style.width = `${newWidth}px`;
  };

  const handleMouseDown = (e) => {
    const startX = e.clientX;
    const startWidth = sidebarRef.current.offsetWidth;

    const handleMouseMove = (moveEvent) => {
      const newWidth = startWidth + (moveEvent.clientX - startX);
      handleResize(Math.max(newWidth, 20)); // Minimum width
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  return (
    <div className={`mt-[72px] h-full flex flex-row`}>
      <div
        ref={sidebarRef}
        className={`flex justify-center overflow-hidden relative bg-slate-200 w-[${width}px]`}
      >
        {children}
        <div
          className={classNames?.slider || DEFAULT_CLASSNAMES.slider}
          onMouseDown={handleMouseDown}
        ></div>
      </div>
      <div
        style={{
          width: `calc(100vw - ${width}px)`,
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Sidebar;
